import React from 'react';
import '../assets/components/_gallery.scss';

const Gallery = () => {
  return (
    <div className="page-container">
      <div className="content-wrapper">
        <div className="section-header">
          <h1>Gallery</h1>
          <p>Visual showcase of my work and projects</p>
        </div>
        
        <div className="clean-card">
          <h3>Visual Showcase Coming Soon!</h3>
          <p>Visual gallery of my projects, research work, and technical achievements.</p>
          <div className="coming-soon">
            <span>Details coming soon</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;